export default __webpack_public_path__ + "static/media/WimgmHome.6b1768c5.png";